// extracted by mini-css-extract-plugin
export var modal = "_mc-0";